import { openCopilotOverlay } from '@/shared/stores/ui';

import type { ProposedAction } from '@/entities/proposed-actions';
import type { SourceProposedActionT } from '@/shared/lib';

export interface DosespotActionPrefill {
  action: ProposedAction;
  sourceProposedAction?: SourceProposedActionT;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    dosespotAction: DosespotActionPrefill;
  }
}

/**
 * Open the DoseSpot action wizard with its payload.
 */
export function openDosespotActionOverlay(prefill: DosespotActionPrefill): void {
  openCopilotOverlay('dosespotAction', prefill);
}
